module.exports = __webpack_public_path__ + "img/li-bg3.70849a69.png";